import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { ApiHook } from '../../hooks/apiHook';
import CurrencyConverter from '../../Currency/CurrencyConverter';
import { useSelector } from 'react-redux';

const Courses = () => {
    const navigate = useNavigate();
    const containerRef = useRef(null);

    const [catId, setCatId] = useState('');
    const [page, setPage] = useState(1);
    const [searchValue, setSearchValue] = useState('');

    const { data: courses, isLoading } = ApiHook.CallCourses(catId, page, searchValue);
    const data = courses?.data;

    const [category, setCategory] = useState(null);
    const [product, setProduct] = useState([]);
    const [hasMore, setHasMore] = useState(true);


    useEffect(() => {
        if (data?.category.length > 0 && !catId) {
            setCatId(data.category[0].id);
        }
        if (data?.category) {
            setCategory(data?.category);
        }
        if (searchValue) {
            setProduct(data?.product);
        } else if (data?.product) {
            setProduct((prevProduct) => [...prevProduct, ...data?.product]);
            setHasMore(data?.product.length === 12);
        }
    }, [data, catId]);

    const DetailsView = (id) => {
        navigate(`/replica/course-details/${id}`);
    };

    const handleBuyNow = (id) => {
        navigate(`/replica-register/${id}`);
    };

    const handleCatClick = (id) => {
        setCatId(id);
        setPage(1);
        if (catId !== id) {
            setProduct([]);
        }
    };

    const onChange = (event) => {
        handleCatClick(event.target.value)
    }


    let debounceTimer;
    const handleSearch = (e) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
            setPage(1)
            setSearchValue(e.target.value);
        }, 500);
    };


    useEffect(() => {
        const handleScroll = () => {
            const container = containerRef.current;
            if (container) {
                const scrollHeight = container.scrollHeight;
                const scrollTop = container.scrollTop;
                const clientHeight = container.clientHeight;

                if (scrollTop + clientHeight >= scrollHeight && !isLoading && hasMore) {
                    setPage((prevPage) => prevPage + 1);
                }
            }
        };

        const container = containerRef.current;
        if (container) {
            container.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (container) {
                container.removeEventListener('scroll', handleScroll);
            }
        };
    }, [isLoading, hasMore]);

    return (
        <div className='main-course-div'>
            <h2 className='fw-bolder text-center mb-4'>Courses</h2>
            <div className='row mb-2'>
                <div className='col-12 col-md-10 mt-3 courseCat-lg'>
                    <div className='course-category d-flex gap-2 flex-wrap'>
                        {category &&
                            category.map((cat) => (
                                <div
                                    key={cat.id}
                                    onClick={() => handleCatClick(cat.id)}
                                    className={`category ${catId === cat.id ? 'active' : ''}`}
                                >
                                    {cat.name}
                                </div>
                            ))}
                    </div>
                </div>
                <div className='courseCat-sm '>
                    <div className="select-wrapper">
                        <select
                            onChange={onChange}
                            // defaultValue={defaultValue}
                            className="styled-select"
                        >
                            {category?.map((cat) => (
                                <option key={cat.id} value={cat.id}>
                                    {cat.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className='col-12 col-md-2 mt-3'>
                    <div className='d-flex align-items-center bg-white ps-2 rounded-start'>
                        <i className="fa-solid fa-magnifying-glass text-secondary"></i>
                        <input
                            type="text"
                            placeholder='Search Course'
                            style={{ height: '3rem', border: 'none', padding: '0 5px', width: '100%' }}
                            onChange={handleSearch}
                        />
                    </div>
                </div>
            </div>


            <div
                ref={containerRef}
                className="row course-container"
            >
                {isLoading && (
                    <div className='d-flex justify-content-center align-items-center'>
                        <i className="fa-solid fa-spinner fa-spin-pulse fa-2xl"></i>
                    </div>
                )}
                {product &&
                    product.map((course) => (
                        <div key={course.id} className="col-xl-3 col-lg-4 col-md-6">
                            <div className='course-cnt'>
                                <img
                                    onClick={() => DetailsView(course.id)}
                                    className='w-100 rounded'
                                    role="button"
                                    style={{ height: '15rem' }}
                                    src={course.image || "/images/product2.jpg"}
                                    alt=""
                                />
                                <h4 onClick={() => DetailsView(course.id)}>
                                    <a href="#">{course.name}</a>
                                </h4>
                                <p onClick={() => DetailsView(course.id)} role='button'>
                                    {`${course.description.slice(0, 100)} ${course.description.length > 100 ? '...' : ''}`}
                                </p>
                                {/* <p style={{ fontWeight: '600', fontSize: '15px', fontFamily: 'sans-serif' }}>PV: {course.pairValue}</p> */}
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div>
                                        {course.price < course.actualPrice &&
                                            data?.defaultCurrency.symbolLeft &&
                                            <span className='text-decoration-line-through text-danger'>
                                                {`${data?.defaultCurrency?.symbolLeft
                                                    } ${CurrencyConverter(
                                                        course.actualPrice,
                                                        data?.defaultCurrency
                                                    )}`} &nbsp;
                                            </span>}
                                        {data?.defaultCurrency.symbolLeft && <span className='fw-bolder fs-4'>
                                            {`${data?.defaultCurrency?.symbolLeft
                                                } ${CurrencyConverter(
                                                    course.price,
                                                    data?.defaultCurrency
                                                )}`}
                                        </span>}



                                    </div>
                                    <div style={{ fontWeight: '600', fontSize: '15px', fontFamily: 'sans-serif', backgroundColor: '#d8d8d8', padding: '5px 10px', borderRadius: '15px' }}>PV: {course.pairValue}</div>
                                    <div
                                        className='course-buyBtn'
                                        onClick={() => handleBuyNow(course.id)}
                                    >
                                        Register now
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default Courses;